import { Component, Input } from '@angular/core';

import { CaResult } from '../core';

@Component({
    selector: 'cmps-ca-live-evaluation',
    templateUrl: './ca-live-evaluation.component.html',
    host: {
        class: 'cmps-ca-live-evaluation',
    },
})
export class CaLiveEvaluationComponent {
    @Input() caResult: CaResult;
    @Input() collapsed: boolean;
}
